import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";

const BUSINESSES = [
  { icon:"🚌", label:"Bus / Transport Company",    query:"corporate offices schools hotels needing transport bus booking",    category:"Transport" },
  { icon:"✈️", label:"Travel Agency",              query:"people planning holidays tour packages travel",                    category:"Transport" },
  { icon:"🚗", label:"Taxi / Cab Service",          query:"corporate offices hospitals airports needing cab taxi service",     category:"Transport" },
  { icon:"📦", label:"Logistics Company",           query:"manufacturers wholesalers exporters needing logistics transport",   category:"Transport" },
  { icon:"🏥", label:"Hospital / Clinic",           query:"senior citizen clubs patient communities health insurance firms",   category:"Healthcare" },
  { icon:"💊", label:"Pharmacy",                    query:"diabetic patients senior citizens chronic illness medicine buyers", category:"Healthcare" },
  { icon:"💪", label:"Gym / Fitness Center",        query:"IT companies corporate wellness housing societies fitness",        category:"Healthcare" },
  { icon:"🦷", label:"Dental Clinic",               query:"corporate offices housing societies dental treatment patients",     category:"Healthcare" },
  { icon:"🏠", label:"Builder / Developer",         query:"people looking to buy flat apartment home buyers investors",        category:"Real Estate" },
  { icon:"🛋️", label:"Interior Designer",          query:"new flat owners newly married couples office renovation",          category:"Real Estate" },
  { icon:"🏡", label:"Property Dealer",             query:"job seekers relocating newly married couples property buyers",     category:"Real Estate" },
  { icon:"📚", label:"Coaching Institute",          query:"JEE NEET students board exam coaching classes parents",            category:"Education" },
  { icon:"🎓", label:"School / College",            query:"parents looking school admission relocation families students",     category:"Education" },
  { icon:"💰", label:"Insurance Company",           query:"new parents vehicle owners home buyers business owners insurance",  category:"Finance" },
  { icon:"🏦", label:"Loan Provider",               query:"home buyers business starters salary earners personal loan",       category:"Finance" },
  { icon:"📊", label:"CA / Tax Consultant",         query:"small businesses freelancers startups GST tax filing",             category:"Finance" },
  { icon:"🍽️", label:"Restaurant / Caterer",       query:"event planners corporate lunch wedding catering offices",           category:"Food & Events" },
  { icon:"💍", label:"Wedding Planner",             query:"engaged couples wedding venues banquet halls jewellery shops",      category:"Food & Events" },
  { icon:"☀️", label:"Solar Company",              query:"commercial buildings factories offices high electricity bill solar", category:"Others" },
  { icon:"💻", label:"IT Company / Developer",      query:"startups SMEs ecommerce digital transformation software needs",    category:"Others" },
  { icon:"🎨", label:"Digital Marketing Agency",    query:"businesses needing marketing social media branding advertising",   category:"Others" },
  { icon:"🏭", label:"Manufacturer / Exporter",     query:"importers distributors wholesalers bulk buyers export",            category:"Others" },
];

const CITIES = ["Delhi","Mumbai","Bangalore","Chennai","Hyderabad","Kolkata","Pune","Ahmedabad","Jaipur","Lucknow","Chandigarh","Surat","Indore","Noida","Gurgaon","Bhopal","Nagpur","Kochi","Coimbatore","Patna","Vadodara","Agra","Varanasi","Meerut","Faridabad"];

const categories = [...new Set(BUSINESSES.map(b=>b.category))];

export default function CustomerFinder() {
  const [biz, setBiz]         = useState(null);
  const [customBiz, setCustomBiz] = useState("");
  const [city, setCity]       = useState("");
  const [step, setStep]       = useState(1);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [error, setError]     = useState("");
  const [cfUsed, setCfUsed]   = useState(parseInt(localStorage.getItem("cf_used")||"0"));
  const [isPremium, setIsPremium] = useState(false);
  const [filter, setFilter]   = useState("all");
  const navigate = useNavigate();

  useEffect(() => {
    API.get("/leads").then(r => setIsPremium(r.data.plan !== "free")).catch(()=>{});
  }, []);

  const search = async () => {
    if (!isPremium && cfUsed >= 2) { navigate("/payment"); return; }
    const finalBiz = customBiz.trim() || biz?.query;
    if (!finalBiz || !city) { setError("Please select your business and city."); return; }
    setError(""); setLoading(true); setResults([]);
    try {
      const res = await API.post("/search-leads", { niche: finalBiz, city, max_results: 20 });
      const data = Array.isArray(res.data) ? res.data : res.data?.leads || [];
      setResults(data);
      if (!isPremium) {
        const n = cfUsed + 1;
        setCfUsed(n);
        localStorage.setItem("cf_used", String(n));
      }
      if (data.length === 0) setError("No results found. Try a different city.");
    } catch(e) {
      const msg = e?.response?.data?.detail || "Search failed.";
      if (msg.includes("pgrade")) navigate("/payment");
      else setError(msg);
    }
    setLoading(false);
  };

  const exportCSV = () => {
    const rows = [["Name","Phone","Address","Score","Intent","Source"]];
    results.forEach(l => rows.push([l.name||"",l.phone||"",l.address||"",l.score||"",l.intent||"",l.source||""]));
    const csv  = rows.map(r => r.map(v => '"'+String(v).replace(/"/g,'""')+'"').join(",")).join("\n");
    const blob = new Blob([csv], {type:"text/csv"});
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href     = url;
    a.download = `customers-${city}-${Date.now()}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const scoreColor = s => s >= 70 ? "#00d4aa" : s >= 50 ? "#f59e0b" : "#f87171";
  const intentColor = { hot:"#00d4aa", warm:"#f59e0b", cold:"#f87171" };
  const srcColor    = { "Google Maps":"#4285f4","JustDial":"#e8441a","IndiaMART":"#ff6600","Sulekha":"#00a651","Naukri":"#2d6df6" };

  const filtered = filter==="all" ? results : results.filter(l=>l.intent===filter);

  return (
    <div style={{ minHeight:"100vh", background:"#050510", color:"#fff", fontFamily:"'DM Sans',sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Syne:wght@700;900&display=swap" rel="stylesheet"/>
      <style>{`@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}`}</style>

      {/* Header */}
      <div style={{ background:"#08080f", borderBottom:"1px solid #ffffff0a", padding:"14px 24px", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:10 }}>
        <div>
          <div style={{ fontFamily:"'Syne',sans-serif", fontSize:20, fontWeight:900, color:"#00d4aa" }}>🎯 Customer Finder</div>
          <div style={{ fontSize:12, color:"#6b7280" }}>Find real customers for your specific business</div>
        </div>
        <div style={{ display:"flex", gap:10, alignItems:"center" }}>
          {!isPremium && (
            <div style={{ background: cfUsed>=2?"#f8717122":"#00d4aa18", border:"1px solid "+(cfUsed>=2?"#f87171":"#00d4aa44"), borderRadius:20, padding:"5px 14px", fontSize:12, color:cfUsed>=2?"#f87171":"#00d4aa", fontWeight:700 }}>
              {cfUsed>=2 ? "🔒 Upgrade to continue" : `🎁 ${2-cfUsed}/2 free searches left`}
            </div>
          )}
          {isPremium && <div style={{ background:"#00d4aa22", border:"1px solid #00d4aa44", borderRadius:20, padding:"5px 14px", fontSize:12, color:"#00d4aa", fontWeight:700 }}>✅ Unlimited searches</div>}
          <button onClick={()=>navigate("/dashboard")} style={{ background:"#ffffff11", color:"#9ca3af", border:"1px solid #ffffff22", borderRadius:10, padding:"7px 14px", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif" }}>← Dashboard</button>
        </div>
      </div>

      <div style={{ maxWidth:1000, margin:"0 auto", padding:"28px 20px" }}>

        {/* Step indicator */}
        {!results.length && (
          <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:28, justifyContent:"center" }}>
            {["Select Business","Select City","Find Customers"].map((s,i) => (
              <div key={i} style={{ display:"flex", alignItems:"center", gap:8 }}>
                <div style={{ width:28, height:28, borderRadius:"50%", background:step>i+1?"#00d4aa":step===i+1?"#00d4aa22":"#ffffff0d", border:"1px solid "+(step>=i+1?"#00d4aa":"#ffffff11"), display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:700, color:step>i+1?"#050510":step===i+1?"#00d4aa":"#6b7280" }}>
                  {step>i+1?"✓":i+1}
                </div>
                <span style={{ fontSize:13, color:step===i+1?"#fff":"#6b7280", fontWeight:step===i+1?700:400 }}>{s}</span>
                {i<2 && <div style={{ width:32, height:1, background:"#ffffff11" }} />}
              </div>
            ))}
          </div>
        )}

        {/* STEP 1: Select Business */}
        {step===1 && (
          <div>
            <div style={{ textAlign:"center", marginBottom:28 }}>
              <h2 style={{ fontFamily:"'Syne',sans-serif", fontSize:26, fontWeight:900, marginBottom:8 }}>What is your business?</h2>
              <p style={{ color:"#9ca3af", fontSize:15 }}>Select your business type — we'll find the right customers for you</p>
            </div>

            {categories.map(cat => (
              <div key={cat} style={{ marginBottom:20 }}>
                <div style={{ color:"#6b7280", fontSize:11, fontWeight:700, marginBottom:10, textTransform:"uppercase", letterSpacing:1 }}>{cat}</div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))", gap:8 }}>
                  {BUSINESSES.filter(b=>b.category===cat).map((b,i) => (
                    <div key={i} onClick={()=>{ setBiz(b); setCustomBiz(""); }} style={{ background:biz?.label===b.label?"#00d4aa22":"#0d0d1f", border:"1px solid "+(biz?.label===b.label?"#00d4aa":"#ffffff0d"), borderRadius:12, padding:"12px 14px", cursor:"pointer", transition:"all 0.2s", display:"flex", alignItems:"center", gap:10 }}>
                      <span style={{ fontSize:20 }}>{b.icon}</span>
                      <div style={{ fontSize:13, fontWeight:biz?.label===b.label?700:400, color:biz?.label===b.label?"#00d4aa":"#d1d5db" }}>{b.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}

            <div style={{ background:"#0d0d1f", border:"1px solid #ffffff0d", borderRadius:16, padding:20, marginTop:8 }}>
              <label style={{ display:"block", color:"#9ca3af", fontSize:11, marginBottom:8, textTransform:"uppercase", letterSpacing:1 }}>Or describe your business</label>
              <input placeholder="e.g. Ambulance service looking for hospitals, Online store looking for buyers..." value={customBiz} onChange={e=>{ setCustomBiz(e.target.value); setBiz(null); }} style={{ width:"100%", background:"#050510", border:"1px solid #ffffff22", borderRadius:10, padding:"12px 14px", color:"#fff", fontFamily:"'DM Sans',sans-serif", fontSize:14, outline:"none", boxSizing:"border-box" }} />
            </div>

            {error && <p style={{ color:"#f87171", textAlign:"center", marginTop:10, fontSize:13 }}>{error}</p>}

            <button onClick={()=>{ if(biz||customBiz.trim()){ setStep(2); setError(""); } else setError("Please select or describe your business."); }} style={{ width:"100%", marginTop:20, background:"linear-gradient(135deg,#00d4aa,#00b894)", color:"#050510", border:"none", borderRadius:12, padding:14, fontFamily:"'DM Sans',sans-serif", fontWeight:700, fontSize:16, cursor:"pointer" }}>
              Next — Select City →
            </button>
          </div>
        )}

        {/* STEP 2: Select City */}
        {step===2 && (
          <div>
            <div style={{ textAlign:"center", marginBottom:28 }}>
              <button onClick={()=>setStep(1)} style={{ background:"#ffffff11", color:"#9ca3af", border:"1px solid #ffffff22", borderRadius:10, padding:"6px 14px", cursor:"pointer", fontSize:13, marginBottom:16, fontFamily:"'DM Sans',sans-serif" }}>← Back</button>
              <h2 style={{ fontFamily:"'Syne',sans-serif", fontSize:26, fontWeight:900, marginBottom:8 }}>Where are your customers?</h2>
              <div style={{ display:"inline-block", background:"#00d4aa22", border:"1px solid #00d4aa44", borderRadius:20, padding:"5px 16px", fontSize:13, color:"#00d4aa", marginBottom:8 }}>
                {biz?.icon} {biz?.label || customBiz}
              </div>
              <p style={{ color:"#9ca3af", fontSize:15 }}>Select the city where you want to find customers</p>
            </div>

            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))", gap:8, marginBottom:20 }}>
              {CITIES.map(c => (
                <div key={c} onClick={()=>setCity(c)} style={{ background:city===c?"#00d4aa22":"#0d0d1f", border:"1px solid "+(city===c?"#00d4aa":"#ffffff0d"), borderRadius:10, padding:"12px", cursor:"pointer", textAlign:"center", fontWeight:city===c?700:400, color:city===c?"#00d4aa":"#9ca3af", transition:"all 0.2s", fontSize:14 }}>
                  {c}
                </div>
              ))}
            </div>

            {error && <p style={{ color:"#f87171", textAlign:"center", marginBottom:10, fontSize:13 }}>{error}</p>}

            <button onClick={search} disabled={loading||!city} style={{ width:"100%", background:loading?"#1a1a2e":"linear-gradient(135deg,#00d4aa,#00b894)", color:loading?"#6b7280":"#050510", border:"none", borderRadius:12, padding:14, fontFamily:"'DM Sans',sans-serif", fontWeight:700, fontSize:16, cursor:loading||!city?"not-allowed":"pointer" }}>
              {loading ? (
                <span style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:10 }}>
                  <span style={{ display:"inline-block", animation:"spin 1s linear infinite" }}>⚡</span>
                  Searching across all platforms...
                </span>
              ) : "🎯 Find My Customers →"}
            </button>
          </div>
        )}

        {/* Results */}
        {results.length > 0 && (
          <div>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16, flexWrap:"wrap", gap:10 }}>
              <div>
                <h2 style={{ fontFamily:"'Syne',sans-serif", fontSize:22, fontWeight:900, marginBottom:4 }}>✅ {results.length} Potential Customers Found</h2>
                <p style={{ color:"#9ca3af", fontSize:13 }}>{biz?.label||customBiz} · {city} · sorted by purchase intent</p>
              </div>
              <div style={{ display:"flex", gap:10 }}>
                <button onClick={()=>{ setResults([]); setStep(1); setBiz(null); setCity(""); setCustomBiz(""); }} style={{ background:"#ffffff11", color:"#9ca3af", border:"1px solid #ffffff22", borderRadius:10, padding:"8px 14px", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif" }}>New Search</button>
                <button onClick={exportCSV} style={{ background:"#00d4aa22", color:"#00d4aa", border:"1px solid #00d4aa44", borderRadius:10, padding:"8px 16px", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif", fontWeight:700 }}>⬇ Export CSV</button>
              </div>
            </div>

            {/* Source breakdown */}
            <div style={{ display:"flex", gap:8, marginBottom:16, flexWrap:"wrap" }}>
              {["all","hot","warm","cold"].map(f => (
                <button key={f} onClick={()=>setFilter(f)} style={{ background:filter===f?"#00d4aa22":"#0d0d1f", color:filter===f?"#00d4aa":"#9ca3af", border:"1px solid "+(filter===f?"#00d4aa44":"#ffffff11"), borderRadius:20, padding:"5px 14px", cursor:"pointer", fontSize:12, fontFamily:"'DM Sans',sans-serif", fontWeight:filter===f?700:400 }}>
                  {f==="all"?"All":"🔥"} {f.charAt(0).toUpperCase()+f.slice(1)} {f!=="all"&&`(${results.filter(l=>l.intent===f).length})`}
                </button>
              ))}
              <div style={{ marginLeft:"auto", display:"flex", gap:6, flexWrap:"wrap" }}>
                {Object.entries(results.reduce((a,l)=>{ a[l.source]=(a[l.source]||0)+1; return a; },{})).map(([src,cnt])=>(
                  <span key={src} style={{ background:(srcColor[src]||"#333")+"22", color:srcColor[src]||"#9ca3af", borderRadius:20, padding:"4px 12px", fontSize:11, fontWeight:700 }}>{src}: {cnt}</span>
                ))}
              </div>
            </div>

            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {filtered.map((lead,i) => (
                <div key={i} style={{ background:"#0d0d1f", border:"1px solid #ffffff0d", borderRadius:16, padding:18, display:"grid", gridTemplateColumns:"52px 1fr auto", gap:14, alignItems:"start" }}>
                  <div style={{ width:48, height:48, borderRadius:12, background:scoreColor(lead.score||0)+"18", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", border:"1px solid "+scoreColor(lead.score||0)+"44" }}>
                    <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:900, color:scoreColor(lead.score||0), fontSize:18, lineHeight:1 }}>{lead.score||"?"}</div>
                    <div style={{ fontSize:7, color:"#6b7280", marginTop:2 }}>SCORE</div>
                  </div>
                  <div>
                    <div style={{ fontWeight:700, fontSize:15, marginBottom:5 }}>{lead.name}</div>
                    <div style={{ display:"flex", gap:14, fontSize:13, flexWrap:"wrap", marginBottom:5 }}>
                      {lead.phone && <a href={`tel:${lead.phone}`} style={{ color:"#00d4aa", textDecoration:"none", fontWeight:600 }}>📞 {lead.phone}</a>}
                      {lead.address && <span style={{ color:"#9ca3af" }}>📍 {lead.address?.slice(0,50)}</span>}
                    </div>
                    <div style={{ display:"flex", gap:10, fontSize:12, flexWrap:"wrap" }}>
                      {lead.rating>0 && <span style={{ color:"#f59e0b" }}>⭐ {lead.rating} ({lead.total_ratings})</span>}
                      {lead.website && <a href={lead.website} target="_blank" rel="noreferrer" style={{ color:"#a855f7", textDecoration:"none" }}>🌐 Website</a>}
                    </div>
                  </div>
                  <div style={{ display:"flex", flexDirection:"column", gap:6, alignItems:"flex-end" }}>
                    <span style={{ background:(srcColor[lead.source]||"#333")+"22", color:srcColor[lead.source]||"#9ca3af", border:"1px solid "+(srcColor[lead.source]||"#333")+"44", borderRadius:7, padding:"3px 10px", fontSize:10, fontWeight:700, whiteSpace:"nowrap" }}>{lead.source}</span>
                    <span style={{ background:(intentColor[lead.intent]||"#f59e0b")+"22", color:intentColor[lead.intent]||"#f59e0b", borderRadius:7, padding:"3px 10px", fontSize:10, fontWeight:700, textTransform:"uppercase" }}>{lead.intent||"warm"}</span>
                  </div>
                </div>
              ))}
            </div>

            {!isPremium && cfUsed >= 2 && (
              <div style={{ background:"#0d0d1f", border:"2px solid #00d4aa44", borderRadius:20, padding:32, textAlign:"center", marginTop:24 }}>
                <div style={{ fontSize:36, marginBottom:12 }}>🔒</div>
                <h3 style={{ fontFamily:"'Syne',sans-serif", fontSize:20, fontWeight:900, marginBottom:10 }}>Free Searches Used</h3>
                <p style={{ color:"#9ca3af", marginBottom:20 }}>Upgrade to get unlimited Customer Finder searches + 500–Unlimited leads/month</p>
                <button onClick={()=>navigate("/payment")} style={{ background:"linear-gradient(135deg,#00d4aa,#00b894)", color:"#050510", border:"none", borderRadius:12, padding:"13px 32px", fontFamily:"'DM Sans',sans-serif", fontWeight:700, fontSize:15, cursor:"pointer" }}>🚀 Upgrade Now</button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
